export const OPN_STATUS = {
  running: ["bg-sky-100 text-sky-700", "Berjalan"],
  pending_adjust: ["bg-amber-50 text-amber-700", "Menunggu penyesuaian"],
  matched: ["bg-emerald-50 text-emerald-700", "Selesai — cocok"],
  adjusted: ["bg-emerald-50 text-emerald-700", "Disesuaikan"],
  cancelled: ["bg-slate-100 text-slate-600", "Dibatalkan"],
};

export const fmtDT = (s) => (s ? new Date(s).toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "-");

export const diffClass = (d) => (d === null || d === undefined ? "text-slate-400" : d === 0 ? "text-emerald-600" : d < 0 ? "text-rose-600" : "text-sky-600");

export const beep = (ok) => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator(); const g = ctx.createGain();
    o.connect(g); g.connect(ctx.destination); o.frequency.value = ok ? 1400 : 300; g.gain.value = 0.15;
    o.start(); o.stop(ctx.currentTime + (ok ? 0.08 : 0.25));
  } catch {}
  if (navigator.vibrate) navigator.vibrate(ok ? 40 : [80, 40, 80]);
};

export function OpnStatusBadge({ status, testId }) {
  const [cls, label] = OPN_STATUS[status] || OPN_STATUS.running;
  return <span className={`text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap ${cls}`} data-testid={testId}>{label}</span>;
}
